
// Footer menus open/close
function footerMobileMenus() {

  if( window.innerWidth <= desktopBreakPoint ) { // Mobile
    // Only show active menus
    $('.footer-menu').children('ul').hide();
    $('.footer-menu.active').children('ul').show();
    // Click on menu heading
    $('.footer-menu > h3').off().click(function(e) {
      e.preventDefault();
      var thisFooterMenu = $(this).parent('.footer-menu');
      // Close all footer menus
      $('.footer-menu').not(thisFooterMenu).children('ul').slideUp(mobileMenuSlideTime);
      $('.footer-menu').not(thisFooterMenu).removeClass('active');
      // Open selected menu
      thisFooterMenu.children('ul').slideToggle(mobileMenuSlideTime);
      thisFooterMenu.toggleClass('active');
    });
  }
  else { // Desktop
    // Show all menus
    $('.footer-menu').children('ul').show();
    // Prevent interaction with menu heading
    $('.footer-menu > h3').off().click(function(e) {
      e.preventDefault();
    });
  }

}
footerMobileMenus();
$(window).resize ( function() {	footerMobileMenus(); });
